module.exports = __webpack_public_path__ + "img/worldwide_travel_insurance.446d9953.webp";